<template>
  <button
    :id="id"
    :type="type"
    :aria-controls="ariaControls"
    :aria-expanded="ariaExpanded"
    :aria-haspopup="ariaHaspopup"
    :aria-label="ariaLabel"
    :aria-labelledby="ariaLabelledby"
    :data-bs-dismiss="dataBsDismiss"
    :data-bs-target="dataBsTarget"
    :data-bs-toggle="dataBsToggle"
    :class="[buttonSize, buttonVariant, classes, {'disabled': loading}]"
    :disabled="disabled"
    @click="$emit('click')"
    class="btn btn-rounded"
  >
    <span
      class="btn-content"
      :class="[{'opacity-0': loading}, contentClasses]"
    >
      <slot />
    </span>

    <v-progress-circular v-if="loading" />
  </button>
</template>

<script>

import VProgressCircular from '../VProgressCircular/VProgressCircular.vue';

export default {
  name: 'VBtn',
  components: {
    VProgressCircular,
  },
  emits: ['click'],
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: 'button',
    },
    color: {
      type: String,
      default: 'primary',
    },
    outlined: Boolean,
    pill: Boolean,
    soft: Boolean,
    size: {
      type: String,
      default: 'md',
    },
    disabled: Boolean,
    loading: Boolean,
    dataBsDismiss: {
      type: String,
      required: false,
      default: null,
    },
    dataBsToggle: {
      type: String,
      required: false,
      default: null,
    },
    dataBsTarget: {
      type: String,
      required: false,
      default: null,
    },
    ariaLabel: {
      type: String,
      required: false,
      default: null,
    },
    ariaLabelledby: {
      type: String,
      required: false,
      default: null,
    },
    ariaHaspopup: {
      type: String,
      required: false,
      default: null,
    },
    ariaExpanded: {
      type: String,
      required: false,
      default: null,
    },
    ariaControls: {
      type: String,
      required: false,
      default: null,
    },
    contentClasses: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    buttonSize() {
      return this.size ? `btn-${this.size}` : '';
    },
    buttonVariant() {
      return this.color ? `btn-${this.outlined ? 'outline-' : ''}${this.color}` : '';
    },
    classes() {
      return {
        'btn-pill': this.pill,
        'btn-soft': this.outlined && this.soft,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "VBtn";
</style>
